import React from 'react'
import FormTextField, { FormTextFieldProps } from './FormTextField'
import { Typography, InputAdornment } from '@mui/material'

interface FormCurrencyFieldProps extends Omit<FormTextFieldProps, 'type' | 'startIcon'> {
  currency?: string
}

const FormCurrencyField: React.FC<FormCurrencyFieldProps> = ({ currency = 'KES', ...props }) => {
  return (
    <FormTextField
      {...props}
      type="number"
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 'bold' }}>
                {currency}
              </Typography>
            </InputAdornment>
          )
        }
      }}
    />
  )
}

export default FormCurrencyField
